import React from 'react'

const privacyPolicyPage = props => {
    return (
        <section className="home_hero FlexVrCenter" style={{padding: '0', height: '100%'}}>
            <embed src="/custom_docs/PrivacyPolicy/AV_Hero_Privacy_Policy.pdf" width="100%" height="100%" />
        </section>
    )
}

export default privacyPolicyPage